import * as React from "react";
import { Button as AButton, Col, Row, Spin } from "antd";
import { ButtonProps } from "antd/es/button";
import { LoadingOutlined } from "@ant-design/icons";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";

type type = "primary" | "secondary";

const bem = new BemHelper("button-protec");

type Props = Omit<ButtonProps, "type"> & {
  type?: type;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

export const ButtonProtec = ({
  type,
  leftIcon,
  rightIcon,
  children,
  loading,
  className,
  ...props
}: Props) => {
  const btnProps: ButtonProps = { ...props };

  switch (type) {
    case "secondary":
      className = classNames(className, bem.modifier("secondary"));
      break;

    default:
      className = classNames(className, bem.modifier("primary"));
  }

  return (
    <AButton className={classNames(bem.block(), className)} {...btnProps} style={btnProps.style}>
      <Row justify='center' align='middle' gutter={5} wrap={false}>
        {loading && (
          <Col style={{ display: "flex", alignItems: "center" }}>
            <Spin
              size={btnProps.size == "middle" ? "default" : btnProps.size}
              indicator={<LoadingOutlined spin />}
            />
          </Col>
        )}
        {!loading && (
          <>
            {leftIcon && <Col style={{ display: "flex", alignItems: "center" }}>{leftIcon}</Col>}
            {children && <Col>{children}</Col>}
            {rightIcon && <Col style={{ display: "flex", alignItems: "center" }}>{rightIcon}</Col>}
          </>
        )}
      </Row>
    </AButton>
  );
};
